import medal0 from './medal_0.png'
import medal1 from './medal_1.png'
import medal2 from './medal_2.png'
import medal3 from './medal_3.png'

export const medals = [medal0, medal1, medal2, medal3]
